export default "__VITE_ASSET__a7954169__"